import i18next from 'i18n';

export const yesNoOptions = [
  {
    label: i18next.t('LABEL_YES'),
    value: '1',
  },
  {
    label: i18next.t('LABEL_NO'),
    value: '0',
  },
];
